import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar/NavbarDashboard";
import {
  auth,
  logInWithEmailAndPassword,
  signInWithEmailAndPassword,
  signInWithGoogle,
} from "../firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import TextField from "@mui/material/TextField";
import "../styles/style.css";
import { NavLink } from "react-bootstrap";
import { FcGoogle } from "react-icons/fc";
import rs_logo_f from "../assets/images/roadsense_logo_full.png";
import rs_logo from "../assets/images/roadsense_logo.png";
import NavbarLanding from "../components/Navbar/NavbarLanding";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [user, loading, error] = useAuthState(auth);
  const navigate = useNavigate();
  useEffect(() => {
    if (loading) {
      // for loading screen
      return;
    }
    if (user) navigate("/Dashboard");
  }, [user, loading]);
  return (
    <div className="background">
      <NavbarLanding />

      <div className="container-index expandAnimate">
          <div className="login-header">
            <img src={rs_logo_f} style={{ height: '50px' }}></img>
            <h3>Sign In</h3>
          </div>
            <input
              type="email"
              placeholder="Email address or username"
              className="login_field"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <input
              type="password"
              placeholder="Enter your password"
              className="login_field"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button
              className="login_btn"
              onClick={() => logInWithEmailAndPassword(email, password)}
            >
              Log In
            </button>
            <div className="container-forgot-password">
              Forgot your login details?
              <Link to="/reset" className="forgot-password">Reset password</Link>
            </div>

            <div class="line-container">
              <div class="line"></div>
              <div class="or-text">OR</div>
            </div>


            <button className="login-google" onClick={signInWithGoogle}>
              <FcGoogle style={{ fontSize: '2em' }}/>
              Login with Google
            </button>
            <div className="container-create-account">
              Don't have an account?{" "}
              <Link to="/register" className="create-account">Create an Account</Link> now.
            </div>
          </div>
    </div>
  );
}
export default Login;
